export default __webpack_public_path__ + "57b3e708b232fdcb64f9cb115cdda7bb.ttf";